import iconColor from "../../assets/imgs/icon_color.png";
import React, { Component } from "react";
import { Layout as Footer, Tooltip } from "antd";
import { versionService } from "../../services";

export default class AppFooter extends Component {
  unmounted = false;

  constructor(props) {
    super(props);

    this.state = {
      version: sessionStorage.getItem("version"),
    };
  }

  componentDidMount() {
    const { version } = this.state;

    versionService
      .getVersion()
      .then((ver) => {
        if (this.unmounted) return;
        if (ver && ver !== version) {
          this.setState({ version: ver });
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }

  componentWillUnmount() {
    this.unmounted = true;
  }

  render() {
    const { version } = this.state;

    return (
      <div>
        <Footer
          style={{
            textAlign: "center",
            paddingTop: 20,
            paddingBottom: 10,
            ...this.props.style,
          }}
        >
          <Tooltip title="Anestech">
            {"Powered by "}
            <a
              href="http://www.anestech.com.br/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={iconColor} alt="Logo" />
            </a>
          </Tooltip>
          <br />
          {version ? `v${version}` : null}
        </Footer>
      </div>
    );
  }
}
